// //@ts-nocheck
// import React, { useState, useRef } from 'react';

// const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
// const ACCEPTED_TYPES = [".doc", ".docx", ".pdf"];

// const FileUpload = ({
//   label = "Resume",
//   name = "resume",
//   accept = ".pdf,.doc,.docx",
//   required = false,
//   error,
//   onChange,
//   isUploading = false
// }) => {
//   const [isDragging, setIsDragging] = useState(false);
//   const [fileName, setFileName] = useState('');
//   const fileInputRef = useRef(null);
//   const [validationError, setValidationError] = useState("");

//   const validateFile = (file) => {
//     const fileExt = file.name.toLowerCase().slice(file.name.lastIndexOf("."));
//     if (!ACCEPTED_TYPES.includes(fileExt)) {
//       setValidationError("Invalid file type. Only .doc, .docx, .pdf allowed.");
//       return false;
//     }
//     if (file.size > MAX_FILE_SIZE) {
//       setValidationError("File size exceeds 20MB limit.");
//       return false;
//     }
//     setValidationError("");
//     return true;
//   };

//   const handleDragEnter = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsDragging(false);
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsDragging(false);

//     const file = e.dataTransfer.files[0];
//     if (file && validateFile(file)) {
//       setFileName(file.name);
//       onChange({ target: { name, files: [file] } });
//     }
//   };


//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && validateFile(file)) {
//       setFileName(file.name);
//       onChange(e);
//     }
//   };

//   const handleClick = () => {
//     fileInputRef.current?.click();
//   };

//   return (
//     <div className="space-y-2">
//       <label className="text-sm font-medium text-gray-700">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>

//       <div
//         className={`relative border border-dashed rounded-lg p-6 cursor-pointer
//           ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-gray-50'}
//           ${error || validationError ? 'border-red-500' : ''}
//           hover:bg-gray-100 transition-colors duration-200`}
//         onDragEnter={handleDragEnter}
//         onDragLeave={handleDragLeave}
//         onDragOver={handleDragOver}
//         onDrop={handleDrop}
//         onClick={handleClick}
//       >
//         <input
//           ref={fileInputRef}
//           type="file"
//           name={name}
//           accept={accept}
//           onChange={handleFileChange}
//           className="hidden"
//           required={required}
//         />

//         <div className="flex flex-col items-center justify-center space-y-3">
//           <button
//             type="button"
//             className="rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//           >
//             Upload
//           </button>

//           <div className="text-center">
//             <p className="text-sm text-gray-600">
//               Drop or select file (.doc / .docx / .pdf upto 20MB)
//             </p>
//           </div>

//           {fileName && (
//             <div className="mt-2 text-sm text-blue-600">
//               Selected: {fileName}
//             </div>
//           )}
//         </div>
//       </div>

//       {error || validationError && (
//         <p className="text-sm text-red-500 mt-1">{error || validationError}</p>
//       )}
//     </div>
//   );
// };

// export default FileUpload;
//@ts-nocheck
import React, { useState, useRef } from 'react';


const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
const ACCEPTED_TYPES = [".doc", ".docx", ".pdf"];

const FileUpload = ({
  label = "Resume",
  name = "resume",
  accept = ".pdf,.doc,.docx",
  required,
  error,
  onChange,
  isUploading = false,
  resume
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);
  const [validationError, setValidationError] = useState("");
  
  const validateFile = (file) => {
    // Reset previous errors
    setValidationError("");

    // Check if file exists
    if (!file) {
      setValidationError("Please select a file.");
      return false;
    }

    // Check file extension
    const fileExt = file.name.toLowerCase().slice(file.name.lastIndexOf("."));
    if (!ACCEPTED_TYPES.includes(fileExt)) {
      setValidationError("Invalid file type. Only .doc, .docx, .pdf allowed.");
      return false;
    }

    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      setValidationError("File size exceeds 20MB limit.");
      return false;
    }

    // Check if file is empty
    if (file.size === 0) {
      setValidationError("File is empty.");
      return false;
    }

    return true;
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isUploading) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (isUploading) return;

    const file = e.dataTransfer.files[0];
    if (file && validateFile(file)) {
      setFileName(file.name);
      onChange({ target: { name, files: [file] } });
    }
  };

  const handleFileChange = (e) => {
    if (isUploading) return;

    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setFileName(file.name);
      onChange(e);
    }
  };

  const handleClick = () => {
    if (!isUploading) {
      fileInputRef.current?.click();
    }
  };

  return (
    <div className="space-y-1 md:space-y-2 lg:space-y-2">
      <label className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">
        {label}  {required === 'required' && (
            <span className="text-red-500 ml-1">*</span>
          )}
      </label>

      <div
        className={`relative border border-dashed rounded-lg p-6 cursor-pointer
          ${isDragging ? 'border-indigo-500 bg-blue-50' : 'border-gray-300 bg-gray-50'}
          ${error == '404' || validationError ? 'border-red-500' : ''}
          ${resume?.status === 200 ? 'border-green-500' : ''}
          ${isUploading ? 'cursor-not-allowed opacity-75' : 'hover:bg-gray-100'}
          transition-all duration-200`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <input
          ref={fileInputRef}
          type="file"
          name={name}
          accept={accept}
          onChange={handleFileChange}
          className="hidden"
          required={required}
          disabled={isUploading}
        />

        <div className="flex flex-col items-center justify-center space-y-3">
          <button
            type="button"
            disabled={isUploading}
            className={`rounded-md px-3 py-1.5 text-sm font-semibold text-white shadow-sm
              ${isUploading
                ? 'button-hover cursor-not-allowed'
                : 'button-hover'}
              focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
              transition-colors duration-200`}
          >
            {isUploading ? (
              <div className="flex items-center space-x-2 flex-row-reverse gap-x-2">
                <div className="simple-spinner">
                  <span></span>
                </div>
                <span> Upload</span>
              </div>
            ) : (
              ' Upload'
            )}
          </button>

          <div className="text-center">
            {
              error == '404' && (
                <p className='text-sm text-red-500'>
                  Resume update to failed. Try Again
                </p>
              )
            }
           {!error && resume?.status !== 200 && (
              <p className="text-sm text-gray-600">
                Drop or select file (.doc / .docx / .pdf up to 20MB)
              </p>
            )}
            {
              resume?.status === 200 && (
                <p className="text-green-600">Resume uploaded successfully!</p>
              )
            }
          </div>

          {fileName && (
            <div className="!mt-1 text-sm text-color">
              Selected: {fileName}
            </div>
          )}
        </div>
      </div>

      {(error || validationError) && (
        <p className="text-sm text-red-500 mt-1">{error == '404' || validationError}</p>
      )}
    </div>
  );
};

export default FileUpload;